import { urlize } from '@common/helpers/url';
import AskQuestionToAgentFormContainer from '@react/cta/components/AskQuestionToAgentFormContainer';
import FindLocalAgent from '@react/shared/components/FindLocalAgent';
import Main from '@react/shared/components/Main';
import Separator from '@react/shared/components/Separator';
import { GoogleSearchSuggestion } from '@sly/core/api/types/search';
import { CONSULTATION_REQUESTED } from '@sly/core/constants/actionTypes';
import {
  leadSourceMap,
  marketingChannelMap,
  marketingMediumMap,
} from '@sly/core/constants/uuidActions';
import { useRouter } from 'next/router';
import { useRef } from 'react';
import MostSearchedRegions from 'sly/agentsPage/components/AgentsContent/MostSearchedRegions';
import AgentsRegionPageAgents from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageData/AgentsRegionPageAgents';
import { AgentsRegionPageDataProps } from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageData/AgentsRegionPageData.types';
import AgentsRegionPageHeader from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageData/AgentsRegionPageHeader';
import AgentsRegionPageNoAgents from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageData/AgentsRegionPageNoAgents';
import { eventNames, useEvents } from 'sly/services/events';

export default function Page({
  title,
  locationName,
  agentsList,
  postSubmit,
  titleRef,
}: AgentsRegionPageDataProps) {
  const { events } = useEvents();
  const router = useRouter();
  const localAgentRef = useRef<HTMLDivElement>(null);
  const onLocationSearch = (result: GoogleSearchSuggestion) => {
    events.track(eventNames.FormSubmitted, {
      form: 'search',
      location: 'agents search',
      values: {
        search: result.displayText,
      },
    });

    const [city, state] = result.name.replace(/\d+/g, '').split(', ');
    router.push(`/agents/region/${urlize(city)}-${state}`);
  };

  const onHeaderClick = () => {
    if (localAgentRef.current) {
      localAgentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Main>
      <AgentsRegionPageHeader
        title={title}
        titleRef={titleRef}
        onClick={onHeaderClick}
      />
      <Separator fullWidth />
      {agentsList.length > 0 ? (
        <AgentsRegionPageAgents agentsList={agentsList} />
      ) : (
        <AgentsRegionPageNoAgents locationName={locationName} />
      )}
      <Separator fullWidth />
      <div
        className='my-0 mx-auto w-full md:w-[var(--col6)]'
        data-tp-id='gen-div-b3547bfe-dc34-42ef-b3ca-3fb78b4dab99'
      >
        <AskQuestionToAgentFormContainer
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          hasLocation
          actionType={CONSULTATION_REQUESTED}
          postSubmit={postSubmit}
          mode={{
            leadSource: leadSourceMap.AskAgentRegionLS,
            channel: marketingChannelMap.OrganicMC,
            medium: marketingMediumMap.OnlineMM,
          }}
        />
      </div>
      <Separator fullWidth />
      <div
        ref={localAgentRef}
        className='mb-16 border-[1px] border-[#DEE0E4] py-12 px-6'
        data-tp-id='gen-div-6bd6e06f-e29c-4edb-9d15-efe050a66d7b'
      >
        <FindLocalAgent
          onLocationSearch={onLocationSearch}
          placeholder='Search by city or ZIP code'
        />
      </div>
      <MostSearchedRegions />
    </Main>
  );
}
